// extracted by mini-css-extract-plugin
export default {"banner":"NewsBanners_banner__6tIOz","info":"NewsBanners_info__5lYmN","title":"NewsBanners_title__WoHyw","text":"NewsBanners_text__7MveV"};